// imports
import { signinWebAuth, signupWebAuth, socialAuthorizationWebAuth } from 'api/webAuth';
import { activatePartner as activatePartnerApi } from 'api/account';
import { saveToken } from 'libs/auth';
import endPoints from 'config/routes/endpoints';
import { formatErrorMessage } from 'libs/notice';
// ------------------------------------
// Constants
// ------------------------------------
export const PROCESS_PARTNER_AUTH_START = 'PROCESS_PARTNER_AUTH_START';
export const PROCESS_PARTNER_AUTH_END = 'PROCESS_PARTNER_AUTH_END';
export const ERROR_AUTH_PARTNER = 'ERROR_AUTH_PARTNER';
export const ACTIVATE_PARTNER_START = 'ACTIVATE_PARTNER_START';
export const ACTIVATE_PARTNER_END = 'ACTIVATE_PARTNER_END';
export const ERROR_ACTIVATE_PARTNER = 'ERROR_ACTIVATE_PARTNER';

// util function
export function handleSaveToken(authInfo) {
  saveToken(authInfo);
  window.appHistory.push(endPoints.activatePartnerSuccess);
}

// ------------------------------------
// Actions
// ------------------------------------
export function processPartnerAuthStart(social=false) {
  return ({ type: PROCESS_PARTNER_AUTH_START, payload: {social: social}});
}

export function processPartnerAuthEnd(payload = {}) {
  return ({ type: PROCESS_PARTNER_AUTH_END, payload });
}

export function errorPartnerAuth(payload = {}) {
  return ({ type: ERROR_AUTH_PARTNER, payload });
}

export function activatePartnerStart() {
  return ({ type: ACTIVATE_PARTNER_START });
}

export function activatePartnerEnd(payload = {}) {
  return ({ type: ACTIVATE_PARTNER_END, payload });
}

export function errorPartnerActivation(payload = {}) {
  return ({ type: ERROR_ACTIVATE_PARTNER, payload });
}


export function activatePartner(authInfo, userInfo, cb = () => {}) {
  return (dispatch) => {
    dispatch(activatePartnerStart());
    cb({ showEmailVerifyModal: true });
    activatePartnerApi(authInfo.accessToken, userInfo)
      .then(() => {
        dispatch(activatePartnerEnd());
        handleSaveToken(authInfo);
      })
      .catch((error) => {
        const formattedError = formatErrorMessage(error);
        cb({ message: formattedError, closeEmailVerifyModal: true });
        dispatch(errorPartnerActivation(error));
      });
  };
}

export function signinPartnerAuthRecurring(userInfo, cb = () => {}) {
  return (dispatch) => {
    // api call
    signinWebAuth(userInfo)
      .then((res) => {
        dispatch(processPartnerAuthEnd(userInfo));
        dispatch(activatePartner({ accessToken: res.accessToken }, userInfo, cb));
      })
      .catch(() => {
        cb({ errorRecurring: true });
      });
  };
}

export function signupPartnerAuth(userInfo, cb = () => {}) {
  return (dispatch) => {
    dispatch(processPartnerAuthStart());
    // api call
    signupWebAuth(userInfo)
      .then(() => {
        dispatch(processPartnerAuthEnd(userInfo));
        cb({ recurringLogin: true });
      })
      .catch((error = {}) => {
        cb({ message: error.description });
        dispatch(errorPartnerAuth(error));
      });
  };
}

export function signinPartnerAuth(userInfo, cb = () => {}) {
  return (dispatch) => {
    dispatch(processPartnerAuthStart());
    // api call
    signinWebAuth(userInfo)
      .then((res = {}) => {
        dispatch(processPartnerAuthEnd(userInfo));
        dispatch(activatePartner({ accessToken: res.accessToken }, userInfo, cb));
      })
      .catch((error = {}) => {
        const errorDescription = error.description || '';
        if (errorDescription.indexOf('A verification email has been sent to your inbox.') !== -1) {
          dispatch(processPartnerAuthEnd(userInfo));
          cb({ recurringLogin: true });
        } else {
          cb({ message: error.description });
          dispatch(errorPartnerAuth(error));
        }
      });
  };
}

export function socialAuthorization(connection, userInfo) {
  return (dispatch) => {
    dispatch(processPartnerAuthStart(true));
    // api call
    socialAuthorizationWebAuth(connection, userInfo)
      .then(() => {
        dispatch(processPartnerAuthEnd());
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/activatePartner.js